export const API_URL = process.env.REACT_APP_API_URL || "";
export const JSON_URL = process.env.REACT_APP_JSON_URL || "";
export const CONTENT_JSON_URL = process.env.REACT_APP_CONTENT_JSON_URL || "";
export const BASE_URL = process.env.REACT_APP_BASE_URL || "/";
export const SENTRY_DSN_URL = process.env.REACT_APP_SENTRY_DSN_URL;
export const SHARE_URL = process.env.REACT_APP_SHARE_URL || "";
export const IMAGES_URL = process.env.REACT_APP_IMAGES_URL || "";
export const SQUAD_IMAGE_URL = process.env.REACT_APP_SQUAD_IMAGE_URL || "/squads/";

export const LABEL_DATE_FORMAT = "LLL d - h:mma ZZZZ";
export const LOCALE = "en";

export const LIVE_SCORING_FETCH_TIMING = 10 * 1000;

export const PRE_SEASON_ROUND_MAP: Record<string, string> = {
	1: "A",
	2: "B",
	3: "C",
	4: "D",
	5: "E",
};
